(function ($) {
  Drupal.behaviors.productFullFiltersV1 = {
    attach: function (context) {
      if (this.attached) {
        return;
      }
      this.attached = true;

      // this js is also picked up by shade_picker_v3 and product_full_shades_v1
      // shared classes and events
      var $template = $('.product-full-filters-v1', context);

      $template.each(function () {
        var $toggle = $template.find('.js-product-full-filters-toggle');
        var $content = $template.find('.js-product-full-filters-content');
        var $buttons = $template.find('.js-product-full-filter');

        function filterToggle() {
          $toggle.attr('aria-expanded', $toggle.attr('aria-expanded') === 'true' ? 'false' : 'true').toggleClass('filter-open');
          $content.toggleClass('product-full-filters__content--open');
        }

        // Toggle self open and close
        $toggle.once().on('click', function (e) {
          e.preventDefault();
          filterToggle();
        });

        // Toggle filter display on button click
        if ($buttons.length) {
          $buttons.each(function () {
            var $this = $(this);

            $this.on('click', function () {
              filterToggle();
            });
          });
        }
      });
    },
    attached: false
  };
})(jQuery);
